import { render, staticRenderFns } from "./StorageLocation.vue?vue&type=template&id=0815b3ad&scoped=true&"
import script from "./StorageLocation.vue?vue&type=script&lang=js&"
export * from "./StorageLocation.vue?vue&type=script&lang=js&"
import style0 from "./StorageLocation.vue?vue&type=style&index=0&id=0815b3ad&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0815b3ad",
  null
  
)

export default component.exports